<template>
    <div>
        <div class="contrainer">
            <div class="row text-modal-redeem">
                <div class="col-12 text-center">
                    <div class="title">
                        ยืนยันการลุ้นรางวัล
                    </div>
                    <div class="detail">
                        จำนวน {{ pointDraw }} สิทธิ์ลุ้นรางวัล <br />
                        คุณต้องการใช้
                        {{ totalPoint }} คะแนนในการลุ้นนี้ใช่หรือไม่
                    </div>
                    <img :src="campaign.fullImageUrl" class="img-detail" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import Util from "@/helper/Utility.js";
import CacheHelper from "@/helper/CacheHelper.js";

export default {
    name: "DrawConfirmRedeem",
    props: {
        lbl: Object,
        campaign: Object
    },
    data: function() {
        return {
            cacheHelper: new CacheHelper(),
            msg: "",
            totalPoint: ""
        };
    },
    created: function() {
        this.pointDraw = this.cacheHelper.getCache("point_draw");
        var datetime = DatetimeHelper.getDatetimeFullFormat(
            this.campaign.expireDate
        );
        this.msg = Util.stringFormat(this.lbl.confirm_redeem.draw, datetime);
        this.calculatePoint();
    },
    methods: {
        calculatePoint() {
            // console.log(this.campaign)
            this.totalPoint = this.campaign.pointPerUnit * this.pointDraw;
        }
    }
};
</script>
<style lang="scss">
@import "@/components/Modal/Redeem/ConfirmRedeem/Component/cfModal.scss";
</style>
